export const TABLE_LABELS = {
  loading: 'Loading...',
  noResultsToDisplay: 'No results to display',
  unknownColumn: 'Unknown Column',
}

export const TABLE_EMPTY_STATE_LABELS = {
  clearFiltersTitle: 'Clear filters',
  filteredDescription: 'Try adjusting or clearing your filters.',
  defaultHeader: 'No data available',
  defaultSubHeader:
    'Once you add items, they will appear in this table. Get started by adding your first entry.',
  noResultsTitle: 'No results found',
  noResultsDescription: (searchValue: string, entityName?: string) =>
    `We couldn't find any${entityName ? ` ${entityName}` : ''} records matching "${searchValue}". Try adjusting your search term or clearing filters to see more results.`,
}

export const TABLE_FILTER_BAR_LABELS = {
  searchPlaceholder: 'Search...',
  addFilter: 'Add filter',
  searchFilters: 'Search filters',
  clearAll: 'Clear all',
  clearAllFilters: 'Clear all filters',
  downloadCsv: 'Download CSV',
  removeFilter: 'Remove filter',
  clearFilter: 'Clear filter',
  timePeriod: 'Time period',
  datePresets: {
    last7Days: 'Last 7 days',
    last30Days: 'Last 30 days',
    last90Days: 'Last 90 days',
    last12Months: 'Last 12 months',
  },
  filterPlaceholder: (headerName?: string) => `Filter ${headerName}...`,
}

export const TABLE_COLUMN_CUSTOMIZATION_LABELS = {
  editColumns: 'Edit columns',
  searchColumns: 'Search columns',
  resetToDefault: 'Reset columns to default',
}

export const TABLE_DATE_FILTER_LABELS = {
  from: 'From',
  to: 'To',
  cancel: 'Cancel',
  apply: 'Apply',
  rangeTooLong: (years: number) => `Pick a range of up to ${years} years.`,
}
